
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { PortfolioItem, Campaign } from '../types';
import { CDN_URLS, OCI_FOLDERS } from '../config';

export const portfolioItems: PortfolioItem[] = [
  {
    id: 'personal-styling',
    titleKey: 'portfolioPage_service_personalStyling_title',
    descriptionKey: 'portfolioPage_service_personalStyling_description',
    imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}portrait/portret_1_weiss.jpg`,
    categoryKey: 'portfolio_category_personal',
    isActive: true,
    pricingTiers: [
      {
        id: 'online',
        nameKey: 'portfolioPage_package_online',
        priceKey: 'price_personal_styling_online',
        basePriceEUR: 150,
        featuresKey: [
          'portfolio_feature_1hr_video_call',
          'portfolio_feature_style_questionnaire',
          'portfolio_feature_personalized_mood_board'
        ]
      },
      {
        id: 'ai-enhanced',
        nameKey: 'portfolioPage_package_aiEnhanced',
        priceKey: 'price_personal_styling_ai',
        basePriceEUR: 250,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_online_features',
          'portfolio_feature_virtual_try_on_session',
          'portfolio_feature_ai_lookbook',
          'portfolio_feature_retail_search'
        ]
      },
      {
        id: 'in-person',
        nameKey: 'portfolioPage_package_inPerson',
        priceKey: 'price_personal_styling_in_person',
        basePriceEUR: 500,
        featuresKey: [
          'portfolio_feature_all_ai_features',
          'portfolio_feature_in_person_consultation',
          'portfolio_feature_hands_on_styling'
        ]
      }
    ]
  },
  {
    id: 'wardrobe-curation',
    titleKey: 'portfolioPage_service_wardrobeCuration_title',
    descriptionKey: 'portfolioPage_service_wardrobeCuration_description',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1556905055-8f358a7a47b2?q=80&w=800&auto=format&fit=crop`,
    categoryKey: 'portfolio_category_wardrobe',
    isActive: true,
    pricingTiers: [
      {
        id: 'online',
        nameKey: 'portfolioPage_package_online',
        priceKey: 'price_wardrobe_curation_online',
        basePriceEUR: 200,
        featuresKey: [
          'portfolio_feature_wardrobe_analysis',
          'portfolio_feature_declutter_guide',
          'portfolio_feature_shopping_list'
        ]
      },
      {
        id: 'ai-enhanced',
        nameKey: 'portfolioPage_package_aiEnhanced',
        priceKey: 'price_wardrobe_curation_ai',
        basePriceEUR: 300,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_online_features',
          'portfolio_feature_ai_outfit_pairing',
          'portfolio_feature_seasonal_capsule'
        ]
      },
      {
        id: 'in-person',
        nameKey: 'portfolioPage_package_inPerson',
        priceKey: 'price_wardrobe_curation_in_person',
        basePriceEUR: 600,
        featuresKey: [
          'portfolio_feature_all_ai_features',
          'portfolio_feature_in_person_consultation',
          'portfolio_feature_hands_on_styling'
        ]
      }
    ]
  },
  {
    id: 'business-workshops',
    titleKey: 'portfolioPage_service_businessWorkshops_title',
    descriptionKey: 'portfolioPage_service_businessWorkshops_description',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1556761175-5973dc0f32e7?q=80&w=800&auto=format&fit=crop`,
    categoryKey: 'portfolio_category_specialty',
    isActive: true,
    pricingTiers: [
      {
        id: 'team-workshop',
        nameKey: 'portfolioPage_package_teamWorkshop',
        priceKey: 'price_business_workshop_team',
        basePriceEUR: 1200,
        featuresKey: [
          'portfolio_feature_team_style_guide',
          'portfolio_feature_brand_identity_alignment',
          'portfolio_feature_group_qa'
        ]
      },
      {
        id: 'executive-branding',
        nameKey: 'portfolioPage_package_executiveBranding',
        priceKey: 'price_business_workshop_executive',
        basePriceEUR: 2500,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_executive_presence',
          'portfolio_feature_wardrobe_analysis',
          'portfolio_feature_personal_shopping_day'
        ]
      },
      {
        id: 'corporate-event',
        nameKey: 'portfolioPage_package_corporateEvent',
        priceKey: 'price_business_workshop_corporate',
        basePriceEUR: 5000,
        featuresKey: [
          'portfolio_feature_keynote_speech',
          'portfolio_feature_pop_up_styling',
          'portfolio_feature_digital_palette'
        ]
      }
    ]
  },
  {
    id: 'event-styling',
    titleKey: 'portfolioPage_service_eventStyling_title',
    descriptionKey: 'portfolioPage_service_eventStyling_description',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1566737236500-c8ac43014a67?q=80&w=800&auto=format&fit=crop`,
    categoryKey: 'portfolio_category_events',
    isActive: true,
    pricingTiers: [
      {
        id: 'online',
        nameKey: 'portfolioPage_package_online',
        priceKey: 'price_event_styling_online',
        basePriceEUR: 100,
        featuresKey: [
          'portfolio_feature_event_consultation',
          'portfolio_feature_3_outfit_proposals',
          'portfolio_feature_accessorizing_guide'
        ]
      },
      {
        id: 'ai-enhanced',
        nameKey: 'portfolioPage_package_aiEnhanced',
        priceKey: 'price_event_styling_ai',
        basePriceEUR: 180,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_online_features',
          'portfolio_feature_event_virtual_try_on',
          'portfolio_feature_pose_variation_check'
        ]
      },
      {
        id: 'in-person',
        nameKey: 'portfolioPage_package_inPerson',
        priceKey: 'price_event_styling_in_person',
        basePriceEUR: 400,
        featuresKey: [
          'portfolio_feature_all_ai_features',
          'portfolio_feature_in_person_consultation',
          'portfolio_feature_hands_on_styling'
        ]
      }
    ]
  },
  {
    id: 'individual-shopping',
    titleKey: 'portfolioPage_service_individualShopping_title',
    descriptionKey: 'portfolioPage_service_individualShopping_description',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?q=80&w=800&auto=format&fit=crop`,
    categoryKey: 'portfolio_category_wardrobe',
    isActive: true,
    pricingTiers: [
      {
        id: 'online',
        nameKey: 'portfolioPage_package_online',
        priceKey: 'price_individual_shopping_online',
        basePriceEUR: 120,
        featuresKey: [
          'portfolio_feature_shopping_consultation',
          'portfolio_feature_curated_shopping_list',
          'portfolio_feature_style_integration_session'
        ]
      },
      {
        id: 'ai-enhanced',
        nameKey: 'portfolioPage_package_aiEnhanced',
        priceKey: 'price_individual_shopping_ai',
        basePriceEUR: 220,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_online_features',
          'portfolio_feature_ai_product_search',
          'portfolio_feature_vto_shortlist'
        ]
      },
      {
        id: 'in-person',
        nameKey: 'portfolioPage_package_inPerson',
        priceKey: 'price_individual_shopping_in_person',
        basePriceEUR: 450,
        featuresKey: [
          'portfolio_feature_all_ai_features',
          'portfolio_feature_in_person_consultation',
          'portfolio_feature_hands_on_styling'
        ]
      }
    ]
  },
  {
    id: 'makeup-advisory',
    titleKey: 'portfolioPage_service_makeupAdvisory_title',
    descriptionKey: 'portfolioPage_service_makeupAdvisory_description',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1487412720507-e7ab37603c6f?q=80&w=800&auto=format&fit=crop`,
    categoryKey: 'portfolio_category_specialty',
    isActive: true,
    pricingTiers: [
      {
        id: 'online',
        nameKey: 'portfolioPage_package_online',
        priceKey: 'price_makeup_advisory_online',
        basePriceEUR: 80,
        featuresKey: [
          'portfolio_feature_makeup_video_call',
          'portfolio_feature_product_recommendations',
          'portfolio_feature_technique_guide'
        ]
      },
      {
        id: 'ai-enhanced',
        nameKey: 'portfolioPage_package_aiEnhanced',
        priceKey: 'price_makeup_advisory_ai',
        basePriceEUR: 150,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_online_features',
          'portfolio_feature_ai_face_analysis',
          'portfolio_feature_virtual_makeup_try_on'
        ]
      },
      {
        id: 'in-person',
        nameKey: 'portfolioPage_package_inPerson',
        priceKey: 'price_makeup_advisory_in_person',
        basePriceEUR: 300,
        featuresKey: [
          'portfolio_feature_all_ai_features',
          'portfolio_feature_in_person_consultation',
          'portfolio_feature_hands_on_styling'
        ]
      }
    ]
  },
  {
    id: 'color-analysis',
    titleKey: 'portfolioPage_service_colorAnalysis_title',
    descriptionKey: 'portfolioPage_service_colorAnalysis_description',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1520006403909-838d6b92c22e?q=80&w=800&auto=format&fit=crop`,
    categoryKey: 'portfolio_category_specialty',
    isActive: true,
    pricingTiers: [
      {
        id: 'online',
        nameKey: 'portfolioPage_package_online',
        priceKey: 'price_color_analysis_online',
        basePriceEUR: 90,
        featuresKey: [
          'portfolio_feature_color_consultation',
          'portfolio_feature_digital_palette',
          'portfolio_feature_outfit_color_guide'
        ]
      },
      {
        id: 'ai-enhanced',
        nameKey: 'portfolioPage_package_aiEnhanced',
        priceKey: 'price_color_analysis_ai',
        basePriceEUR: 160,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_online_features',
          'portfolio_feature_ai_color_detection',
          'portfolio_feature_interactive_palette'
        ]
      },
      {
        id: 'in-person',
        nameKey: 'portfolioPage_package_inPerson',
        priceKey: 'price_color_analysis_in_person',
        basePriceEUR: 350,
        featuresKey: [
          'portfolio_feature_all_ai_features',
          'portfolio_feature_in_person_consultation',
          'portfolio_feature_hands_on_styling'
        ]
      }
    ]
  },
  {
    id: 'style-transformation',
    titleKey: 'portfolioPage_service_styleTransformation_title',
    descriptionKey: 'portfolioPage_service_styleTransformation_description',
    imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_portret.jpg`,
    categoryKey: 'portfolio_category_specialty',
    isActive: true,
    pricingTiers: [
      {
        id: 'essential',
        nameKey: 'portfolioPage_package_essential',
        priceKey: 'price_style_transformation_essential',
        basePriceEUR: 450,
        featuresKey: [
          'portfolio_feature_color_analysis',
          'portfolio_feature_wardrobe_edit',
          'portfolio_feature_style_guide'
        ]
      },
      {
        id: 'complete',
        nameKey: 'portfolioPage_package_complete',
        priceKey: 'price_style_transformation_complete',
        basePriceEUR: 850,
        isFeatured: true,
        featuresKey: [
          'portfolio_feature_all_essential_features',
          'portfolio_feature_personal_shopping',
          'portfolio_feature_makeup_lesson',
          'portfolio_feature_follow_up'
        ]
      },
      {
        id: 'vip',
        nameKey: 'portfolioPage_package_vip',
        priceKey: 'price_style_transformation_vip',
        basePriceEUR: 1500,
        featuresKey: [
          'portfolio_feature_all_complete_features',
          'portfolio_feature_photoshoot',
          'portfolio_feature_hair_consultation',
          'portfolio_feature_vip_concierge'
        ]
      }
    ]
  }
];

const now = new Date();
const nextMonth = new Date();
nextMonth.setMonth(now.getMonth() + 1);

export const campaigns: Campaign[] = [
  {
    id: 'new-year-new-style',
    nameKey: 'campaign_new_year_title',
    descriptionKey: 'campaign_new_year_desc',
    serviceIds: ['personal-styling', 'wardrobe-curation'],
    imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_silvester.png`,
    badgeKey: 'campaign_badge_limited_time',
    discountPercentage: 20,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'executive-presence',
    nameKey: 'campaign_executive_title',
    descriptionKey: 'campaign_executive_desc',
    serviceIds: ['business-workshops', 'personal-styling'],
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop`,
    badgeKey: 'campaign_badge_professional',
    discountAmount: 50,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'palette-perfect',
    nameKey: 'campaign_color_title',
    descriptionKey: 'campaign_color_desc',
    serviceIds: ['color-analysis', 'makeup-advisory'],
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1500917293891-ef795e70e1f6?q=80&w=800&auto=format&fit=crop`,
    badgeKey: 'campaign_badge_bestseller',
    discountPercentage: 15,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'membership-boost',
    nameKey: 'campaign_membership_boost_title',
    descriptionKey: 'campaign_membership_boost_desc',
    serviceIds: [],
    targetTierIds: ['premium', 'advanced'],
    imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_444.png`,
    badgeKey: 'campaign_badge_exclusive',
    discountPercentage: 25,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'event-glamour',
    nameKey: 'campaign_event_glamour_title',
    descriptionKey: 'campaign_event_glamour_desc',
    serviceIds: ['event-styling', 'makeup-advisory'],
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1515934751635-c81c6bc9a2d8?q=80&w=800&auto=format&fit=crop`,
    badgeKey: 'campaign_badge_events',
    discountPercentage: 10,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'smart-shopper',
    nameKey: 'campaign_shopping_title',
    descriptionKey: 'campaign_shopping_desc',
    serviceIds: ['individual-shopping', 'wardrobe-curation'],
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?q=80&w=800&auto=format&fit=crop`,
    badgeKey: 'campaign_badge_exclusive',
    discountPercentage: 15,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'style-transformation-workshop',
    nameKey: 'campaign_style_transformation_title',
    descriptionKey: 'campaign_style_transformation_desc',
    serviceIds: ['style-transformation'],
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1574634534894-89d7576c8259?q=80&w=800&auto=format&fit=crop`,
    badgeKey: 'campaign_badge_new',
    discountAmount: 100,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'summer-radiant-style',
    nameKey: 'campaign_summer_title',
    descriptionKey: 'campaign_summer_desc',
    serviceIds: ['personal-styling', 'color-analysis', 'individual-shopping'],
    imageUrl: '/campaigns/summer_campaign.png',
    badgeKey: 'campaign_badge_seasonal',
    discountPercentage: 20,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  },
  {
    id: 'easter-spring-renewal',
    nameKey: 'campaign_easter_title',
    descriptionKey: 'campaign_easter_desc',
    serviceIds: ['wardrobe-curation', 'makeup-advisory', 'style-transformation'],
    imageUrl: '/campaigns/easter_campaign.png',
    badgeKey: 'campaign_badge_seasonal',
    discountPercentage: 15,
    isActive: true,
    startDate: now.toISOString(),
    endDate: nextMonth.toISOString()
  }
];
